import axios from "axios";
const global = require("../config/config");

const send2Mail = async (campos, infoJson) => {
  try {
    var options = {
      method: "POST",
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? "easymanager" : "easydata"
      }/mail/enviar2Email/`,
      params: { dealer_id: infoJson.Stand.Anunciante },
      headers: {
        "Content-Type": "application/json",
        token: process.env.REACT_APP_TOKEN_API,
      },
      data: {
        ...campos,
        user: process.env.REACT_APP_EMAIL_USERNAME,
        pass: process.env.REACT_APP_EMAIL_PASSWORD,
        SECRET_KEY: process.env.REACT_APP_RECAPCHA_SECRETKEY,
      },
    };

    return await axios
      .request(options)
      .then((response) => {
        return response;
      })
      .catch(function (error) {
        console.error(
          `[apiEmail] ${options.url} falhou:`,
          error.response?.status ?? error.code ?? "sem resposta do servidor",
          error.response?.data ?? error.message
        );
        return (
          error.response ?? { status: 0, data: { message: error.message } }
        );
      });
  } catch (error) {
    console.error("error", error.message);
  }
};

const sendMail = async (campos, infoJson) => {
  try {
    var options = {
      method: "POST",
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? "easymanager" : "easydata"
      }/mail/enviarEmail/`,
      params: { dealer_id: infoJson.Stand.Anunciante },
      headers: {
        "Content-Type": "application/json",
        token: process.env.REACT_APP_TOKEN_API,
      },
      data: {
        ...campos,
        user: process.env.REACT_APP_EMAIL_USERNAME,
        pass: process.env.REACT_APP_EMAIL_PASSWORD,
        SECRET_KEY: process.env.REACT_APP_RECAPCHA_SECRETKEY,
      },
    };

    return await axios
      .request(options)
      .then((response) => {
        return response;
      })
      .catch(function (error) {
        console.error(
          `[apiEmail] ${options.url} falhou:`,
          error.response?.status ?? error.code ?? "sem resposta do servidor",
          error.response?.data ?? error.message
        );
        return (
          error.response ?? { status: 0, data: { message: error.message } }
        );
      });
  } catch (error) {
    console.error("error", error.message);
  }
};

export { sendMail, send2Mail };
